import { isObject } from 'lodash-es'

import { ShippingAddressFormSchema } from 'Components/ShippingAddressForm/ShippingAddressForm.types'

import { STREET_NUMBER_SPLIT_STRING } from 'Constants/constants'
import { EMPTY_SELECT_OPTION } from 'Constants/form'

import { AddressInput } from 'Portal/__generated__/globalTypes'

import { isFalsy } from '../isFalsy/isFalsy.util'

export const splitStreetNumber = (
  fullStreet?: string,
): {
  street: string
  streetNumber: string
} => {
  if (!fullStreet) return { street: '', streetNumber: '' }

  const splitIndex = fullStreet?.lastIndexOf(STREET_NUMBER_SPLIT_STRING) || -1

  if (splitIndex === -1) return { street: fullStreet, streetNumber: '' }

  return {
    street: fullStreet.substring(0, splitIndex),
    streetNumber: fullStreet.substring(
      splitIndex + STREET_NUMBER_SPLIT_STRING.length,
      fullStreet.length,
    ),
  }
}

/**
 * Helper function to get the value of a select option from a form.
 * @returns option value or empty string
 */
export const getSelectValue = <
  T extends {
    label: string
    value: string
  } | null,
>(
  option?: T,
) => option?.value ?? ''

/**
 * Helper function to create a select option object for a form.
 * @returns option object or null
 */
export const createSelectOption = <T extends string>(
  option?: T | { label?: T | null; value?: T | null } | null,
  fallback: { label: string; value: string } | null = EMPTY_SELECT_OPTION,
): { label: string; value: string } | null => {
  if (isObject(option)) {
    return isFalsy(option?.label) || isFalsy(option?.value)
      ? fallback
      : (option as { label: string; value: string })
  }

  return isFalsy(option)
    ? fallback
    : { label: option as string, value: option as string }
}

export const parseShippingAddressBeforeSubmit = (
  formData: ShippingAddressFormSchema | null,
): AddressInput | null => {
  if (!formData) {
    return null
  }

  return {
    _label: formData._label,
    city: formData.city,
    country: getSelectValue(formData.country),
    name: formData.name,
    nameAddition: formData.nameAddition,
    street: `${formData.street} ${formData.streetNumber}`,
    zipcode: formData.zipcode,
  }
}

export const formatPhoneNumber = (number: string): string =>
  number.startsWith('00') ? number.replace('00', '+') : number

export const validatePhoneNumber = (number: string): string =>
  number.startsWith('+') ? number : `+${number}`
